import Head_nurse_management from "@/pages/roster-management/Head_nurse_management";
import { useGroupSelection } from "@hooks/useGroupSelection.ts";
import useNurses from "@hooks/useNurses.ts";
import ErrorComponent from "@components/ui/error.tsx";
import useGradeConfig from "@hooks/useGradeConfig.ts";
import { useShiftsQuery } from "@hooks/roster-craete/useShiftsQuery.ts";
import { useIsAdmin } from "@hooks/useAuth.ts";
import LoadingDots from "@/components/LoadingDots";
import { useTeamsQuery } from "@/hooks/roster-craete/useTeamsQuery";

export default function RosterManagement() {
  const { selectedGroupId } = useGroupSelection();
  const isAdmin = useIsAdmin();

  // Promise.all 패턴 적용: 로딩/에러 상태를 병렬적으로 처리
  const nursesResult = useNurses(selectedGroupId);
  const teamsResult = useTeamsQuery(isAdmin ? (selectedGroupId ?? "") : null);
  const configResult = useGradeConfig({
    selectedGroupId: isAdmin ? (selectedGroupId ?? "") : null,
  });
  const shiftsResult = useShiftsQuery(isAdmin ? (selectedGroupId ?? "") : "");

  const isLoading = [
    nursesResult.isLoading,
    teamsResult.isLoading,
    configResult.isLoading,
    shiftsResult.isLoading,
  ].some(Boolean);

  const isError = [
    nursesResult.isError,
    teamsResult.isError,
    shiftsResult.isError,
  ].some(Boolean);

  const nurseError = nursesResult.error;
  const teamsErrorData = teamsResult.error;
  const configError = configResult.error;
  const shiftsError = shiftsResult.error;

  if (isError) {
    return (
      <ErrorComponent
        errorMsg={
          nurseError?.message ||
          shiftsError?.message ||
          teamsErrorData?.message ||
          (configError as Error)?.message ||
          "데이터를 불러오는 중 오류가 발생했습니다."
        }
      />
    );
  }

  return (
    <div className="pb-20 mgmt_inner  ">
      {isLoading ? (
        <div className="w-full h-full flex items-center justify-center">
          <LoadingDots />
        </div>
      ) : (
        <div className="w-full min-w-[1200px] flex items-start justify-start">
          <Head_nurse_management />
        </div>
      )}
    </div>
  );
}
